import { Component, ChangeDetectorRef, ViewChildren, AfterViewInit, ElementRef } from '@angular/core';
import { ProductsService } from './services/products.service';
import { Product } from './services/product';
import { SocialButton } from './SocialButton';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  readonly sunIconPath = 'assets/images/sun.svg'
  readonly moonIconPath = 'assets/images/moon.svg'

  @ViewChildren('productRef', { read: ElementRef }) productsRefs;

  desktop: boolean = false;

  readonly socialButtons = [
    new SocialButton("gmail", "mailto:elumixor@gmail.com"),
    new SocialButton("github", "https://github.com/elumixor"),
    new SocialButton("facebook", "https://www.facebook.com/elumixor"),
    new SocialButton("instagram", "https://www.instagram.com/elumixor"),
  ]

  nightMode: boolean

  get themeImage(): string {
    return this.nightMode ? this.sunIconPath : this.moonIconPath
  }

  get products(): Product[] {
    return this.productsService.products;
  }

  constructor(private detector: ChangeDetectorRef, private productsService: ProductsService) {
    this.desktop = screen.width > 500;
    addEventListener('resize', () => {
      this.desktop = screen.width > 500
      this.detector.detectChanges();
    })
    // todo: implememnt here logic checking the time of the day and/or user theme to set night mode to true or false
  }
  ngAfterViewInit(): void {
    if (this.productsRefs.first)
      setTimeout(() => this.productsRefs.first.nativeElement.scrollIntoView({ behavior: "smooth" }), 1000)
  }

  switchMode() {
    this.nightMode = !this.nightMode
    this.detector.detectChanges()
  }
}
